import { createFileRoute } from "@tanstack/react-router";

import { CompanyDetailPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/companies/$company_id")({
  component: CompanyDetailRoute,
});

function CompanyDetailRoute() {
  const { company_id } = Route.useParams();
  return <CompanyDetailPage companyId={company_id} />;
}
